import React from "react";
import { FaSearch, FaPencilRuler, FaCode, FaRocket } from "react-icons/fa";

const steps = [
  {
    step: "01",
    title: "Zbulim & përputhje",
    body: "Intervista me palët e interesuara, metrika suksesi, kufizime dhe model dorëzimi që përputhet me profilin tuaj të riskut.",
    icon: FaSearch,
  },
  {
    step: "02",
    title: "Arkitekturë zgjidhjeje",
    body: "Rrjedha UX, dizajn teknik dhe plan pikash kufitare me kritere pranimi — para se implementimi të përshpejtohet.",
    icon: FaPencilRuler,
  },
  {
    step: "03",
    title: "Ndërtim & siguri cilësie",
    body: "Dorëzim iterativ me shqyrtim kodi, kontrolle të automatizuara, mjedise staging dhe dukshmëri javore për palët e interesuara.",
    icon: FaCode,
  },
  {
    step: "04",
    title: "Lançim & aftësim",
    body: "Hedhje në prodhim, monitorim, manuale operimi dhe transferim njohurish që ekipi juaj të operojë me besim.",
    icon: FaRocket,
  },
];

function Process() {
  return (
    <section className="process section-pad" id="approach">
      <div className="container">
        <div className="section-heading">
          <span className="section-tag">Modeli i punës</span>
          <h2>Si arrijmë rezultate të parashikueshme</h2>
          <p>
            Procesi ynë është për palët që kanë nevojë për qeverisje, gjurmueshmëri dhe
            rigorozitet inxhinierik — pa ngadalësuar inovacionin.
          </p>
        </div>

        <div className="process-grid">
          {steps.map(({ step, title, body, icon: Icon }) => (
            <article key={step} className="process-card">
              <div className="process-card-top">
                <span className="process-step">{step}</span>
                <span className="process-icon-wrap" aria-hidden="true">
                  <Icon />
                </span>
              </div>
              <h3>{title}</h3>
              <p>{body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Process;
